import { render, staticRenderFns } from "./CustomerTTYTDetail.vue?vue&type=template&id=35b1b8ee&scoped=true&"
import script from "./CustomerTTYTDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerTTYTDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTTYTDetail.vue?vue&type=style&index=0&id=35b1b8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1b8ee",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/CustomerTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fcustomer%2FCustomerTTYTDetail.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports